import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "filepdfFilled"
const FilepdfFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.148 15.245V16.649H18.22V18.215H20.88V19.553H18.22V22.114H16.473V15.244z" />
          <path
            fillRule="evenodd"
            d="M12.234 15.245C13.484 15.245 14.424 15.683 14.974 16.51Q15.378 17.115 15.49 17.99 15.528 18.293 15.53 18.629V18.64Q15.527 18.979 15.487 19.289 15.454 19.57 15.388 19.823L15.382 19.847Q15.242 20.377 14.975 20.791L14.965 20.807Q14.819 21.033 14.634 21.223 14.56 21.298 14.48 21.368 14.277 21.546 14.037 21.683 13.782 21.828 13.49 21.925 13.308 21.985 13.113 22.027 12.703 22.113 12.233 22.114H9.444V15.244zM11.19 16.654V20.704H12.005Q12.107 20.705 12.203 20.698L12.295 20.686Q12.345 20.68 12.392 20.674L12.474 20.657Q12.524 20.647 12.57 20.636 12.607 20.626 12.64 20.614 12.692 20.599 12.74 20.58 12.77 20.57 12.795 20.558 12.846 20.537 12.894 20.512L12.95 20.48Q12.992 20.456 13.033 20.429L13.093 20.385 13.158 20.333 13.217 20.28 13.28 20.214Q13.303 20.19 13.323 20.163 13.356 20.125 13.384 20.083 13.406 20.056 13.426 20.025L13.474 19.941 13.51 19.87Q13.531 19.828 13.55 19.785 13.567 19.747 13.583 19.707L13.62 19.6 13.645 19.518Q13.659 19.468 13.67 19.418L13.69 19.33 13.712 19.195Q13.724 19.112 13.732 19.025 13.74 18.96 13.746 18.893L13.752 18.643V18.635L13.75 18.582Q13.75 18.505 13.746 18.431L13.74 18.349Q13.733 18.279 13.724 18.212L13.719 18.166Q13.706 18.076 13.689 17.99C13.5 17.118 12.903 16.654 12.004 16.654zM6.047 15.245C6.852 15.245 7.507 15.51 7.948 15.975 8.347 16.395 8.57 16.979 8.57 17.677V17.687Q8.568 17.87 8.547 18.043C8.475 18.653 8.217 19.153 7.812 19.507L7.759 19.552Q7.445 19.809 7.03 19.948L7.011 19.955Q6.576 20.098 6.047 20.1H4.867V22.114H3.118V15.244zM4.867 16.582V18.787H5.626Q5.682 18.787 5.73 18.783H5.744L5.836 18.772Q5.846 18.773 5.857 18.771 5.9 18.766 5.94 18.76L5.968 18.754Q6.006 18.747 6.04 18.737 6.063 18.733 6.084 18.726L6.136 18.71 6.183 18.69Q6.333 18.633 6.448 18.54L6.47 18.522Q6.53 18.47 6.58 18.408L6.59 18.395Q6.716 18.232 6.768 18.007 6.769 17.998 6.773 17.989 6.803 17.849 6.803 17.686V17.678C6.803 16.963 6.366 16.582 5.628 16.582z"
            clipRule="evenodd"
          />
          <path d="M14.25 5.989C14.25 7.232 15.257 8.239 16.5 8.239H21V13.745H14.973V14.462C14.173 13.962 13.223 13.745 12.233 13.745H7.944V14.152C7.366 13.876 6.717 13.745 6.048 13.745H3V2.989C3 2.161 3.672 1.489 4.5 1.489H14.25z" />
          <path d="M19.616 6.739H16.5C16.086 6.739 15.75 6.403 15.75 5.989V2.551z" />
        </svg>
      }
    </span>
  )
}
export default FilepdfFilledIcon
